var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.0689 0.00444268C9.8172 -0.0814355 6.65592 1.08046 4.23378 3.25171C1.81165 5.42296 0.312357 8.4389 0.0435703 11.6806C-0.225216 14.9224 0.756883 18.144 2.78834 20.6846C4.81981 23.2251 7.74656 24.8918 10.968 25.3426L11.0444 25.2789V16.3024H7.86123V12.7372H11.0444V9.93598C11.0444 6.7528 13.0817 4.97021 16.0102 4.97021C16.9486 4.99185 17.8845 5.07693 18.8114 5.22487V8.47172H17.1561C15.6282 8.47172 15.2462 9.23568 15.2462 10.2543V12.7372H18.6204L18.0474 16.3024H15.2462V25.2789C15.206 25.2759 15.1655 25.2759 15.1253 25.2789L15.1826 25.3235C18.3736 24.838 21.2612 23.1586 23.2612 20.6251C25.2612 18.0916 26.2244 14.893 25.9558 11.6764C25.6873 8.45979 24.2072 5.4652 21.8148 3.29837C19.4224 1.13153 16.2963 -0.0458274 13.0689 0.00444268Z"}));
}

Facebook.defaultProps = {"width":"26","height":"26","viewBox":"0 0 26 26"};

module.exports = Facebook;

Facebook.default = Facebook;
